<template>
<VueSlickgrid
  name="clientStatement"
  :headerTitle="'Statement'|pgettext('client|Statement')"
  :items="ds"
  checkbox-row-selection
  footer-totals
  export-to-csv
  :exportToCsvFilename="'client-statement'|pgettext('filename')"
  :columnDefaults="b_7315092382398562_columnDefaults"
  :columns="b_7315092382398562_columns"
  ref="grid"
  v-if="loaded"
  @command="evh_7315092382398562_command($event, {})"
>
</VueSlickgrid>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcCompanyStatement extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  getQueryParameters(...args: any[]) {
    return { client_id: this.oid }
  }

  @Prop({
    required: true,
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('browse_client_statement', { parameters: this.getQueryParameters })
  }

  ux!: any;
  b_7315092382398562_columnDefaults!: any;
  b_7315092382398562_columns!: any;

  async $$load_b_7315092382398562_columns() {
    return [{
      field: "transaction_date",
      name: this.$fn.pgettext("CompanyStatement", "Date"),
      type: "date",
    }
      ,
    {
      field: "transaction_type",
      name: this.$fn.pgettext("CompanyStatement", "Type"),
      width: "100px",
      formatter: {
        name: "chain",
        formatters: [{
          name: "gettext",
          conversion: "StartCase",
          context: "CompanyStatementType",
          filterInput: true,
        }
          ,
        {
          name: "cellclass",
          value: (row) => ({
            'font-weight-bold': true,
            'bg-red-200': row.transaction_type === 'invoice',
            'bg-green-200': row.transaction_type === 'payment',
          }),
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "transaction_number",
      name: this.$fn.pgettext("CompanyStatement", "Number"),
      width: "120px",
      type: "command",
      formatter: {
        name: "link",
        href: "#",
      }
      ,
    }
      ,
    {
      field: "amount",
      name: this.$fn.pgettext("CompanyStatement", "Amount"),
      type: "number",
      formatter: "number",
    }
      ,
    {
      field: "currency",
      name: this.$fn.pgettext("CompanyStatement", "Currency"),
    }
      ,
    {
      field: "balance",
      name: this.$fn.pgettext("CompanyStatement", "Balance"),
      type: "number",
      formatter: "number",
      noFooterTotals: true,
    }
      ,
    ]
  }

  dataMembers = ['ds', 'ux', 'b_7315092382398562_columnDefaults', 'b_7315092382398562_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ds: null,
        ux: null,
        b_7315092382398562_columnDefaults: {
          sortable: false,
          filterable: true,
          resizable: true,
        }
        ,
        b_7315092382398562_columns: null,
      },
    }
  }

  async act_7315092382398562_showModal_7068_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7315092382398562_showModal_7068, alias=undefined
    return {
      name: "Payment",
      props: {
        modal: true,
        oid: $event.data.data.id,
      }
      ,
    }
  }

  async evh_7315092382398562_command_7067_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7315092382398562_command_7067, alias=undefined
    return $event.data.column.id === 'transaction_number' && $event.data.data.transaction_type === 'payment'
  }

  async act_7315092382398562_showModal_7070_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7315092382398562_showModal_7070, alias=undefined
    return {
      name: "Invoice",
      props: {
        modal: true,
        oid: $event.data.data.id,
      }
      ,
    }
  }

  async evh_7315092382398562_command_7069_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7315092382398562_command_7069, alias=undefined
    return $event.data.column.id === 'transaction_number' && $event.data.data.transaction_type === 'invoice'
  }

  async evh_7315092382398562_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_command.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_showModal_7068: actions.ShowModalAction;
    evh_7315092382398562_command_7067: actions.EventHandlerImpl;
    act_7315092382398562_showModal_7070: actions.ShowModalAction;
    evh_7315092382398562_command_7069: actions.EventHandlerImpl;
    evh_7315092382398562_command: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_showModal_7068 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7315092382398562_showModal_7068_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_command_7067 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_showModal_7068,
        event: "command",
        when: this.evh_7315092382398562_command_7067_getWhen,
        displayName: "showModal",
      }
    );
    const act_7315092382398562_showModal_7070 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7315092382398562_showModal_7070_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_command_7069 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_showModal_7070,
        event: "command",
        when: this.evh_7315092382398562_command_7069_getWhen,
        displayName: "showModal",
      }
    );
    const evh_7315092382398562_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_command_7067, evh_7315092382398562_command_7069],
      }
    );
    return {
      act_7315092382398562_showModal_7068,
      evh_7315092382398562_command_7067,
      act_7315092382398562_showModal_7070,
      evh_7315092382398562_command_7069,
      evh_7315092382398562_command,
    }
  }
}

Vue.component("UcCompanyStatement", UcCompanyStatement);

</script>